import { ReactComponent as BankBookIcon } from "customerAttachments/icons/Icon-bank_book.svg"
import { ReactComponent as DrivingLicense } from "customerAttachments/icons/Icon-driving_license.svg"
import { ReactComponent as IdCard } from "customerAttachments/icons/Icon-id_card.svg"
import { ReactComponent as RegistrationForm } from "customerAttachments/icons/Icon-registration_form.svg"
import { AttachmentStatus } from "customerAttachments/types"

export const AttachmentStatusMapping: { [key in AttachmentStatus]: string } = {
  PendingUpload: "未上傳",
  Uploaded: "已上傳",
  UnderReview: "審核中，不可異動",
  PendingReupload: "待重新上傳",
  UploadNotYetAvailable: "領牌後上傳即可",
}

export const TransferAttachMapping = {
  NewScooterOwnerIdCard: { Text: "新車主身分證(正反面)", Icon: IdCard },
  NewScooterOwnerScooterLicense: { Text: "新車主行照資料面", Icon: DrivingLicense },
  NewScooterOwnerAuthorizedLegalRepresentative: { Text: "法定代理人身分證(正反面)", Icon: IdCard },
  NewScooterOwnerAgentIdCard: { Text: "授權人身分證(代理人)(正反面)", Icon: IdCard },
}

export const PurchaseAttachMapping = {
  IdCard: { Text: "車主身分證(正反面)", Icon: IdCard },
  ScooterModificationRegistration: { Text: "機車車輛異動登記書 - 1", Icon: RegistrationForm },
  ScooterModificationRegistrationSecond: { Text: "機車車輛異動登記書 - 2", Icon: RegistrationForm },
  EPAWasteScooterRecyclingControlForm: { Text: "廢機動車輛回收證明 - 1", Icon: RegistrationForm },
  EPAWasteScooterRecyclingControlFormSecond: {
    Text: "廢機動車輛回收證明 - 2",
    Icon: RegistrationForm,
  },
  BankAccount: { Text: "車主存摺", Icon: BankBookIcon },
  SubsidyBonus: {
    Text: "補助加碼證明",
    Icon: RegistrationForm,
  },
  DifferentScooterOwnerId: {
    Text: "舊車車主身份證(正反面) - 1",
    Icon: IdCard,
  },
  DifferentScooterOwnerIdSecond: {
    Text: "舊車車主身份證(正反面) - 2",
    Icon: IdCard,
  },
  StudentIdOrEnrollmentDocument: {
    Text: "學生證或在學證明等文件",
    Icon: RegistrationForm,
  },
  LowOrMiddleIncomeDocument: {
    Text: "中低收入證明文件",
    Icon: RegistrationForm,
  },
  LegalRepresentativeIdCard: {
    Text: "法定代理人身分證(正反面)",
    Icon: IdCard,
  },
  AgentIdCard: {
    Text: "授權人身分證(代理人)(正反面)",
    Icon: IdCard,
  },
  ScooterLicense: {
    Text: "行照資料面",
    Icon: DrivingLicense,
  },
  NewScooterLicenseRegistration: {
    Text: "新領牌照登記書",
    Icon: RegistrationForm,
  },
}

export const IdCards = [
  "IdCard",
  "DifferentScooterOwnerId",
  "DifferentScooterOwnerIdSecond",
  "LegalRepresentativeIdCard",
  "AgentIdCard",
  "NewScooterOwnerIdCard",
  "NewScooterOwnerAuthorizedLegalRepresentative",
  "NewScooterOwnerAgentIdCard",
]
